// Utility to collect all unique content IDs from pmSections and pmScreen
// Matches the old logic: collects from content references and visibility rules
import { List } from 'immutable'

// Helper function to process content IDs into integers
function processContentIds (ids) {
  return Array.from(new Set(ids))
    .map((id) => Number(id))
    .filter((id) => Number.isInteger(id) && !Number.isNaN(id))
}

// Collect content references from content-references-list sections
export function collectContentReferences (pmSections, sectionIds) {
  const contentIds = []
  const contentReferenceTypesIds = new Set()

  sectionIds.forEach((id) => {
    const section = pmSections.get(id)
    if (!section) return
    if (section.get('type') !== 'content-references-list') return
    const references = section.getIn(['data', 'contentReference', 'filter', 'references'], List())
    references.forEach((ref) => {
      const contentId = ref.get('contentId')
      const contentType = ref.get('contentType')
      const contentReferenceTypesId = ref.get('contentReferenceTypesId')
      if (contentId && contentType) {
        contentIds.push(contentId)
      }
      if (contentReferenceTypesId) {
        contentReferenceTypesIds.add(contentReferenceTypesId)
      }
    })
  })
  return {
    contentIds: processContentIds(contentIds),
    uniqueContentReferenceTypesIds: Array.from(contentReferenceTypesIds),
  }
}

// Collect has watched content IDs from visibility rules
export function collectHasWatchedContentIds (pmSections, sectionIds) {
  const contentIds = []
  sectionIds.forEach((id) => {
    const section = pmSections.get(id)
    if (!section) return
    const visibility = section.get('visibility', List())
    visibility.forEach((rule) => {
      const type = rule.get('type')
      if (type === 'user-has-watched' || type === 'content-impression') {
        const contentList = rule.get('content', List())
        contentList.forEach((item) => {
          const contentId = item.get('contentId')
          if (contentId) {
            contentIds.push(contentId)
          }
        })
      }
    })
  })
  return {
    contentIds: processContentIds(contentIds),
  }
}

// Main function to collect all IDs needed for mapping
export function collectContentIds (pmSections, pmScreen) {
  const sectionIds = pmScreen.get('sectionIds', List())
  const { contentIds: referenceContentIds, uniqueContentReferenceTypesIds } =
    collectContentReferences(pmSections, sectionIds)
  const { contentIds: hasWatchedContentIds } = collectHasWatchedContentIds(pmSections, sectionIds)

  // Combine all content IDs into a single array
  const allContentIds = [...referenceContentIds, ...hasWatchedContentIds]

  return {
    contentIds: processContentIds(allContentIds),
    contentReferenceTypesIds: uniqueContentReferenceTypesIds,
  }
}
